import React from 'react';

import carveConfirmationImgPath from 'assets/pngs/carve-confirmation.png';
import { typographyHeebo24 } from 'common-ui/typography';
import styled from 'styled-components';
import { Button } from 'ui-kit';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
`;

const QuestionText = styled.div`
  ${typographyHeebo24}
  margin: 10px 0 30px;
  color: ${(props) => props.theme.color.slate200};
`;

interface CreateCarveQuestionProps {
  setCreateCarve: (value: boolean) => void;
  onNoCarve: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const CreateCarveQuestion: React.FC<CreateCarveQuestionProps> = ({ setCreateCarve, onNoCarve }) => {
  return (
    <Container>
      <img src={carveConfirmationImgPath} alt="Create Carve Icon" />
      <QuestionText>Would you like to create a carve of the offering?</QuestionText>
      <ButtonContainer>
        <Button onClick={onNoCarve} type="secondary" label={'No'}>
          No
        </Button>
        <Button onClick={() => setCreateCarve(true)} label={'Yes'}>
          Yes
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default CreateCarveQuestion;
